module.exports = __webpack_public_path__ + "assets/campaign-account.f658bd0d.svg";